import * as React from "react";

export const Section01 = () => (
  <div className="content">
    <div className="template-block">
      <img
        className="template-double"
        src="/images/resources/escalation/escalation-summary-so.svg"
        alt="Escalation Summary"
      />

      <img
        className="template-double"
        src="/images/resources/escalation/escalation-template-so.svg"
        alt="Escalation Template"
      />
    </div>
  </div>
);
